import { store } from '@/app/store';
import { selectedMarketSelector } from '@/features/selectedMarket/selectedMarketSlice';
import MarketDetail from '@/shared/components/MarketDetail/MarketDetail';
import MarketList from '@/shared/components/MarketList/MarketList';
import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import { isInvestDetailView } from '@/shared/helpers/urlHelper';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useSelector } from 'react-redux';
import { useIsMobile } from '@/shared/hooks/devices';
import { useGetMarketInfoQuery } from '@/features/marketInfo/marketInfoApi';
import GenericErrorComponent from '@/shared/components/GenericErrorComponent/GenericErrorComponent';
import { withTranslation } from 'react-i18next';

const Markets: React.FC = () => {
  const isMobile = useIsMobile();

  const showDetailView = !isMobile || isInvestDetailView(location.search);

  const userSelectedMarket = useSelector(() => selectedMarketSelector.selectAll(store.getState()));

  const selectedMarket = userSelectedMarket[0].market;
  const showListView = (!showDetailView && isMobile) || !isMobile;
  const { error: marketInfoError } = useGetMarketInfoQuery(undefined);

  return (
    <PageWrapper name="markets-page" mainPage={isMobile && !showDetailView}>
      {marketInfoError ? (
        <GenericErrorComponent />
      ) : (
        <IonGrid>
          <IonRow>
            {showListView && (
              <IonCol sizeLg="5" sizeMd="12">
                <MarketList selectedMarket={selectedMarket} />
              </IonCol>
            )}

            {showDetailView && (
              <IonCol sizeLg="7" sizeMd="12">
                <MarketDetail marketId={selectedMarket} />
              </IonCol>
            )}
          </IonRow>
        </IonGrid>
      )}
    </PageWrapper>
  );
};

export default withTranslation()(Markets);
